module.exports = __webpack_public_path__ + "img/bianc.e9f536d2.png";